module.exports = __webpack_public_path__ + "static/media/Nicolas_Martinez_Garcia.c1dceb58.png";